import request from '@/utils/request'

export function getList(data) {
  return request({
    url: '/index/course/getList',
    method: 'post',
    data
  })
}

export function getDetail(data) {
  return request({
    url: '/index/course/getDetail',
    method: 'post',
    data
  })
}

export function getCredit(data) {
  return request({
    url: '/index/course/credit',
    method: 'post',
    data
  })
}